import React from 'react';
import Navbar from '../../components/navbar';
import FormularioHijos from '../../formData/formularioHijos';

function DatosHijos() {
  return (
    <FormularioHijos />
  )
}

export default DatosHijos;
